import { render, staticRenderFns } from "./ScreenFailureScreen.vue?vue&type=template&id=4ea686cb&scoped=true&"
import script from "./ScreenFailureScreen.vue?vue&type=script&lang=js&"
export * from "./ScreenFailureScreen.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFailureScreen.vue?vue&type=style&index=0&id=4ea686cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea686cb",
  null
  
)

export default component.exports